export default __webpack_public_path__ + "d894719707746e0c132ea1e24b1976b4.png";